import { referralActionTypes, userActionTypes } from '../actions/types';
import { referralService } from '../services';
const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};

const getListOfReferred = (referralId, codes, boughtPlan) => {
  return (dispatch, getState) => {
    dispatch(request());

    referralService.findAllReferred(referralId, codes, boughtPlan).then(
      referredList => {
        dispatch(success(referredList));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            referralActionTypes.FETCH_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: referralActionTypes.FETCH_REQUEST };
  }
  function success(referredList) {
    return { type: referralActionTypes.FETCH_SUCCESS, referredList };
  }
};

export const referralActions = {
  getListOfReferred,
};
